// Generated by Melange

import * as JsxRuntime from "react/jsx-runtime";

function IconSidebarSvgTickets(Props) {
  let activeOpt = Props.active;
  const active = activeOpt !== undefined ? activeOpt : false;
  return JsxRuntime.jsxs("svg", {
    children: [
      JsxRuntime.jsx("path", {
        clipRule: "evenodd",
        d: "M15.2533 4.67984C13.8499 3.27488 11.9837 2.50081 9.99531 2.5C5.8984 2.5 2.56393 5.83419 2.56234 9.93237C2.56188 10.9615 2.77302 11.9713 3.17894 12.9035C3.39215 13.3932 3.47516 13.9382 3.33414 14.4533L2.5 17.5L5.67226 16.6679C6.16557 16.5385 6.68516 16.6137 7.15651 16.8084C8.05124 17.1781 9.01511 17.3708 9.99235 17.3711H9.99537C14.0919 17.3711 17.4266 14.0366 17.4283 9.93831C17.429 7.95221 16.6566 6.08474 15.2533 4.67984Z",
        fillRule: "evenodd",
        stroke: active ? "#fff" : "#818C96",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }),
      JsxRuntime.jsx("path", {
        clipRule: "evenodd",
        d: "M15.2533 4.67984C13.8499 3.27488 11.9837 2.50081 9.99531 2.5C5.8984 2.5 2.56393 5.83419 2.56234 9.93237C2.56188 10.9615 2.77302 11.9713 3.17894 12.9035C3.39215 13.3932 3.47516 13.9382 3.33414 14.4533L2.5 17.5L5.67226 16.6679C6.16557 16.5385 6.68516 16.6137 7.15651 16.8084C8.05124 17.1781 9.01511 17.3708 9.99235 17.3711H9.99537C14.0919 17.3711 17.4266 14.0366 17.4283 9.93831C17.429 7.95221 16.6566 6.08474 15.2533 4.67984Z",
        fillRule: "evenodd",
        stroke: active ? "#fff" : "#747F88",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    ],
    height: "20",
    width: "20",
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  });
}

const make = IconSidebarSvgTickets;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
